module.exports = __webpack_public_path__ + "static/media/liftoff-with-oreo-on-zerog-ver-en.3f98133a.png";